import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/nav-bar.css";
import logo from "../assets/images/joozylogo.png";
import { jwtDecode } from "jwt-decode";
import { usePortalScope } from "../context/PortalScopeContext";
import Register from "../pages/auth/register";
import ProfilePage from "../pages/auth/profile";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showRegisterSidebar, setShowRegisterSidebar] = useState(false);
  const [showProfileSidebar, setShowProfileSidebar] = useState(false);
  const { canSwitchPortal, portalScope, setPortalScope } = usePortalScope();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("scope");
    localStorage.removeItem("portalScope");
    sessionStorage.removeItem("auditUnlocked");
    navigate("/login");
  };

  let userRole = null;

  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = jwtDecode(token);
      userRole = decoded.role;
    } catch (err) {
      console.error("Invalid token", err);
      localStorage.removeItem("token");
      navigate("/login");
    }
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Joozy Logo" className="navbar-logo" />
        </Link>

        {/* Hamburger button — visible only on mobile */}
        <button
          className="navbar-toggler"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation"
        >
          <span className="toggler-bar"></span>
          <span className="toggler-bar"></span>
          <span className="toggler-bar"></span>
        </button>

        <ul className={`navbar-menu${menuOpen ? " open" : ""}`}>
          <li className="nav-item">
            <Link
              to="/dashboard"
              className={`nav-link${isActive("/dashboard") ? " active" : ""}`}
              onClick={() => setMenuOpen(false)}
            >
              <i className="bi bi-speedometer2 nav-icon"></i> Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/form"
              className={`nav-link${isActive("/form") ? " active" : ""}`}
              onClick={() => setMenuOpen(false)}
            >
              <i className="bi bi-pencil-square nav-icon"></i> Form
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/cards"
              className={`nav-link${isActive("/cards") ? " active" : ""}`}
              onClick={() => setMenuOpen(false)}
            >
              <i className="bi bi-people nav-icon"></i> All Vendors
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/table"
              className={`nav-link${isActive("/table") ? " active" : ""}`}
              onClick={() => setMenuOpen(false)}
            >
              <i className="bi bi-table nav-icon"></i> Table
            </Link>
          </li>

          {/* Mobile-only: Register, Profile & Logout inside hamburger menu */}
          {userRole === "Admin" && (
            <li className="nav-item nav-item-action mobile-only">
              <button
                className="nav-link nav-btn"
                onClick={() => {
                  navigate("/register");
                  setMenuOpen(false);
                }}
              >
                Add New User
              </button>
            </li>
          )}
          <li className="nav-item nav-item-action mobile-only">
            <button
              className="nav-link nav-btn"
              onClick={() => {
                navigate("/profile");
                setMenuOpen(false);
              }}
            >
              Profile
            </button>
          </li>
          <li className="nav-item nav-item-action mobile-only">
            <button
              className="nav-link nav-btn"
              onClick={() => {
                handleLogout();
                setMenuOpen(false);
              }}
            >
              Logout
            </button>
          </li>
        </ul>

        <div className={`navbar-actions${menuOpen ? " open" : ""}`}>
          {canSwitchPortal && (
            <>
              <div className="navbar-divider desktop-only"></div>
              <div className="portal-scope-switcher">
                <span className="portal-viewing-label">Viewing</span>
                <div className="portal-segmented">
                  <button
                    type="button"
                    className={
                      portalScope === "Global"
                        ? "btn-portal active"
                        : "btn-portal"
                    }
                    onClick={() => setPortalScope("Global")}
                    title="Show Global portal data"
                  >
                    🌐 Global
                  </button>
                  <button
                    type="button"
                    className={
                      portalScope === "Local"
                        ? "btn-portal active"
                        : "btn-portal"
                    }
                    onClick={() => setPortalScope("Local")}
                    title="Show Local portal data"
                  >
                    📍 Local
                  </button>
                </div>
              </div>
            </>
          )}
          {/* Desktop-only: Register, Profile & Logout in actions bar */}
          {userRole === "Admin" && (
            <button
              className="btn-logout desktop-only"
              onClick={() => setShowRegisterSidebar(true)}
            >
              Add New User
            </button>
          )}
          <button
            className="btn-logout desktop-only"
            onClick={() => setShowProfileSidebar(true)}
          >
            Profile
          </button>
          <button className="btn-logout desktop-only" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
      {/* Desktop slide-in sidebars */}
      {showRegisterSidebar && (
        <div className="sidebar-overlay desktop-only">
          <div className="sidebar-panel">
            <button
              type="button"
              className="sidebar-close"
              onClick={() => setShowRegisterSidebar(false)}
            >
              ×
            </button>
            <Register />
          </div>
        </div>
      )}
      {showProfileSidebar && (
        <div className="sidebar-overlay desktop-only">
          <div className="sidebar-panel">
            <button
              type="button"
              className="sidebar-close"
              onClick={() => setShowProfileSidebar(false)}
            >
              ×
            </button>
            <ProfilePage />
          </div>
        </div>
      )}
      {userRole === "Admin" && (
        <Link to="/audit" className="btn-audit-icon" title="Audit Log">
          <i className="bi bi-journal-text"></i>
        </Link>
      )}
    </nav>
  );
};

export default Navbar;
